import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPetsByUserId } from "../../utils";
import { getAuth } from "firebase/auth";

export const fetchUserPets = createAsyncThunk(
  "notifications/fetchUserPets",
  async (_, { rejectWithValue }) => {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error("Usuario no autenticado");
      }

      return await getPetsByUserId(currentUser);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    pets: [],
    status: "idle",
    error: null,
    notifications: 0,
  },
  reducers: {
    incrementNotifications: (state) => {
      state.notifications += 1;
    },
    decrementNotifications: (state) => {
      if (state.notifications > 0) {
        state.notifications -= 1;
      }
    },
    updatePet: (state, action) => {
      const { id, ...updatedData } = action.payload;
      const petIndex = state.pets.findIndex((pet) => pet.id === id);

      if (petIndex !== -1) {
        // Actualización inmutable más eficiente
        state.pets[petIndex] = { ...state.pets[petIndex], ...updatedData };

        // Recalcula notificaciones si cambió en_contacto
        if ("en_contacto" in updatedData) {
          state.notifications = state.pets.reduce((count, pet) => {
            return pet.en_contacto ? count + 1 : count;
          }, 0);
        }
      }
    },
    // Nuevo reducer para actualizar múltiples mascotas
    updateMultiplePets: (state, action) => {
      const updates = action.payload; // Array de {id, ...data}

      updates.forEach(({ id, ...updatedData }) => {
        const petIndex = state.pets.findIndex((pet) => pet.id === id);
        if (petIndex !== -1) {
          state.pets[petIndex] = { ...state.pets[petIndex], ...updatedData };
        }
      });

      // Recalcula notificaciones
      state.notifications = state.pets.reduce((count, pet) => {
        return pet.en_contacto ? count + 1 : count;
      }, 0);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPets.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUserPets.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pets = action.payload || [];

        // Calcula notificaciones de forma más eficiente
        state.notifications =
          action.payload?.reduce((count, pet) => {
            return pet.en_contacto ? count + 1 : count;
          }, 0) || 0;
      })
      .addCase(fetchUserPets.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Error desconocido";
        state.pets = [];
        state.notifications = 0;
      });
  },
});

export const {
  incrementNotifications,
  decrementNotifications,
  updatePet,
  updateMultiplePets,
} = notificationSlice.actions;

export default notificationSlice.reducer;
